import {
  AwardExternalPointsFragment,
  AwardPointsFragment,
  AwardPointsPerFragment,
  AwardVouchersFragment,
  AwardTransactionMoneyDiscountFragment,
  AwardTransactionPercentDiscountFragment,
  AwardMoneyDiscountFragment,
  AwardPriceOverrideFragment,
  AwardBuyAndGetFragment,
  AwardProductDiscountFragment,
  SurveyAwardVouchersFragment,
  AwardExternalFragment,
} from '@occc/graphql';
import { AwardFragment } from '@occc-app/offerHelpers/types';

class AwardHelper {
  isPointsAward = (award: AwardFragment): award is AwardPointsFragment => {
    return award.__typename === 'AwardPoints';
  };

  isPointsPerAward = (award: AwardFragment): award is AwardPointsPerFragment => {
    return award.__typename === 'AwardPointsPer';
  };

  isVouchersAward = (award: AwardFragment): award is AwardVouchersFragment => {
    return award.__typename === 'AwardVouchers';
  };

  isSurveyVouchersAward = (award: AwardFragment): award is SurveyAwardVouchersFragment => {
    return award.__typename === 'AwardVouchers';
  };

  isTransactionMoneyDiscountAward = (
    award: AwardFragment,
  ): award is AwardTransactionMoneyDiscountFragment => {
    return award.__typename === 'AwardTransactionMoneyDiscount';
  };

  isTransactionPercentDiscountAward = (
    award: AwardFragment,
  ): award is AwardTransactionPercentDiscountFragment => {
    return award.__typename === 'AwardTransactionPercentDiscount';
  };

  isExternalPointsAward = (award: AwardFragment): award is AwardExternalPointsFragment => {
    return award.__typename === 'AwardExternalPoints';
  };

  isMoneyDiscountAward = (award: AwardFragment): award is AwardMoneyDiscountFragment => {
    return award.__typename === 'AwardMoneyDiscount';
  };

  isPriceOverrideAward = (award: AwardFragment): award is AwardPriceOverrideFragment => {
    return award.__typename === 'AwardPriceOverride';
  };

  isBuyAndGetAward = (award: AwardFragment): award is AwardBuyAndGetFragment => {
    return award.__typename === 'AwardBuyAndGet';
  };

  isProductDiscountAward = (award: AwardFragment): award is AwardProductDiscountFragment => {
    return award.__typename === 'AwardProductDiscount';
  };

  isExternalAward = (award: AwardFragment): award is AwardExternalFragment => {
    return award.__typename === 'AwardExternal';
  };
}

export const awardHelper = new AwardHelper();
